import {AppState} from '@app/context/context';

const ORDERS_COLUMNS_KEY = 'ordersColumns';

class OrdersColumnsStorage {
    set = (config: AppState['orders']['config']) =>
        localStorage.setItem(ORDERS_COLUMNS_KEY, JSON.stringify(config));

    get = (): AppState['orders']['config'] | null => {
        const storedConfig = localStorage.getItem(ORDERS_COLUMNS_KEY);
        return storedConfig ? JSON.parse(storedConfig) : null;
    };

    clear = () => localStorage.removeItem(ORDERS_COLUMNS_KEY);
}

export const ordersColumnsStorage = new OrdersColumnsStorage();
